/**
 * Domain utility functions for the Tabet Dairies application
 */

export const DOMAIN_CONFIG = {
  ADMIN_DOMAIN: 'admin.tabetdairies.com',
  MAIN_DOMAIN: 'tabetdairies.com',
  LOCALHOST_ADMIN: 'admin.localhost:3000',
  LOCALHOST_MAIN: 'localhost:3000'
} as const;

/**
 * Check if the current domain is the admin domain
 */
export const isAdminDomain = (): boolean => {
  const hostname = window.location.hostname;
  return hostname.startsWith('admin.') || 
         hostname === DOMAIN_CONFIG.ADMIN_DOMAIN ||
         hostname === DOMAIN_CONFIG.LOCALHOST_ADMIN;
};

/**
 * Check if the current domain is the main domain
 */
export const isMainDomain = (): boolean => {
  const hostname = window.location.hostname;
  return hostname === DOMAIN_CONFIG.MAIN_DOMAIN ||
         hostname === DOMAIN_CONFIG.LOCALHOST_MAIN;
};

/**
 * Get the appropriate domain for a given role
 */
export const getDomainForRole = (role: 'super_admin' | 'admin'): string => {
  if (role === 'super_admin') {
    return window.location.protocol + '//' + DOMAIN_CONFIG.ADMIN_DOMAIN;
  }
  return window.location.protocol + '//' + DOMAIN_CONFIG.MAIN_DOMAIN;
};

/**
 * Redirect to the appropriate domain for a given role
 */
export const redirectToDomain = (role: 'super_admin' | 'admin', path: string = '/'): void => {
  const targetDomain = getDomainForRole(role);
  window.location.href = targetDomain + path;
};
